function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// Not using our custom instance of axios here, because auth header is not needed.
import axios from 'axios';

var AmpConfigService = /*#__PURE__*/function () {
  function AmpConfigService() {
    _classCallCheck(this, AmpConfigService);
  }

  _createClass(AmpConfigService, [{
    key: "fetchAmpConfig",
    value: function fetchAmpConfig() {
      if (this.cachedPromise) {
        return this.cachedPromise;
      } else if (typeof window !== 'undefined') {
        this.cachedPromise = axios.get("".concat(window.location.origin, "/amp-config.json")).then(function (response) {
          return response.data;
        });
        return this.cachedPromise;
      } else {
        return Promise.resolve({});
      }
    }
  }]);

  return AmpConfigService;
}();

export default new AmpConfigService();